import { useContext } from 'react'
import { useQuery } from '@maui/react-query'
import { MatiApiClientContext } from '@/providers'

const useMsvApiClient = (ns) => {
  const { msvClient } = useContext(MatiApiClientContext)
  return ns ? msvClient?.[ns] : msvClient
}

export const useValidationQuery = (id, type, options = {}) => {
  const api = useMsvApiClient('validation')
  return useQuery({
    queryFn: () => api.fetch({ id, type }),
    queryKey: ['validation', id],
    ...options
  })
}
